import React, { useState, useEffect } from 'react';
import { LazyImage } from '../atoms';

/**
 * 画像読み込みテスト用コンポーネント
 * CORB問題のデバッグとテストに使用
 */
const ImageTestComponent = () => {
  const [logs, setLogs] = useState([]);

  const addLog = (message, type = 'info') => {
    const timestamp = new Date().toLocaleTimeString();
    setLogs(prev => [...prev, { message, type, timestamp }]);
  };

  const testImages = []; // テスト画像は外部から追加

  const clearLogs = () => setLogs([]);

  const testFetch = async () => {
    for (const image of testImages) {
      try {
        addLog(`テスト開始: ${image.name}`);
        const response = await fetch(image.url, { mode: 'cors' });
        if (response.ok) {
          addLog(`✅ 成功: ${image.name} - ${response.status}`, 'success');
        } else {
          addLog(`❌ 失敗: ${image.name} - ${response.status}`, 'error');
        }
      } catch (error) {
        addLog(`❌ エラー: ${image.name} - ${error.message}`, 'error');
      }
    }
  };

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl font-bold mb-6 text-gray-800">画像読み込みテスト - CORBデバッグ</h1>

        {/* コントロールパネル */}
        <div className="bg-white rounded-lg shadow-md p-4 mb-6">
          <div className="flex gap-4">
            <button
              onClick={testFetch}
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors"
            >
              Fetch APIテスト実行
            </button>
            <button
              onClick={clearLogs}
              className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 transition-colors"
            >
              ログクリア
            </button>
          </div>
        </div>

        {/* 画像テストギャラリー */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
          {testImages.map((image, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="h-48 bg-gray-200 relative">
                <LazyImage
                  src={image.url}
                  alt={image.name}
                  className="w-full h-full object-cover"
                  fallbackSrc={image.fallback}
                  onLoad={() => addLog(`🖼️ 画像読み込み成功: ${image.name}`, 'success')}
                  onError={() => addLog(`🚫 画像読み込み失敗: ${image.name}`, 'error')}
                />
              </div>
              <div className="p-4">
                <h3 className="font-bold text-gray-800">{image.name}</h3>
                <p className="text-sm text-gray-600 break-all">{image.url}</p>
              </div>
            </div>
          ))}
        </div>

        {/* ログ表示 */}
        <div className="bg-white rounded-lg shadow-md">
          <div className="p-4 border-b border-gray-200">
            <h2 className="text-xl font-bold text-gray-800">実行ログ</h2>
          </div>
          <div className="p-4 max-h-96 overflow-y-auto">
            {logs.length === 0 ? (
              <p className="text-gray-500 italic">ログはありません</p>
            ) : (
              <div className="space-y-2">
                {logs.map((log, index) => (
                  <div
                    key={index}
                    className={`text-sm p-2 rounded ${log.type === 'error'
                        ? 'bg-red-50 text-red-700 border border-red-200'
                        : log.type === 'success'
                          ? 'bg-green-50 text-green-700 border border-green-200'
                          : 'bg-gray-50 text-gray-700 border border-gray-200'
                      }`}
                  >
                    <span className="font-mono text-xs text-gray-500">[{log.timestamp}]</span>
                    <span className="ml-2">{log.message}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageTestComponent;
